import React from 'react';
import {FormattedMessage} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import MarriageNocDetailsPersonalInfo from "containers/MarriageNOCDetails/MarriageNOCDetails.PersonalInfo";
import MarriageNocDetailsPreviousEngagement from "containers/MarriageNOCDetails/MarriageNOCDetails.PreviousEngagement";
import MarriageNocDetailsPreviousMarriage from "containers/MarriageNOCDetails/MarriageNOCDetails.PreviousMarriage";
import MarriageNOCDetailsDivorcement from "containers/MarriageNOCDetails/MarriageNOCDetails.Divorcement";
import MarriageNOCDetailsWitnesses from "containers/MarriageNOCDetails/MarriageNOCDetails.Witnesses";
import {updateMarriageNocAction} from "services/marriageNoc/marriageNoc.actions";
import Button from "components/Button/Button";
import MarriageNocDetailsDocuments from "containers/MarriageNOCDetails/MarriageNOCDetails.Documents";
import {isNOCEditable} from "utils/utils";
import {Form} from "react-final-form";

const MarriageNocDetailsForm = ({marriageNOC, initialValues}) => {
  const dispatch = useDispatch();
  const isEditable = isNOCEditable(marriageNOC);

  console.log('Form Component:', {
    marriageNOC,
    initialValues,
  });

  const onSubmit = (values) => {
    console.log('Form Submit Values:', values);
    return dispatch(updateMarriageNocAction(values));
  };

  return (
    <div>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({handleSubmit, pristine, submitting}) => (
          <form onSubmit={handleSubmit}>
            <MarriageNocDetailsPersonalInfo disabled={!isEditable}/>
            <MarriageNocDetailsPreviousEngagement disabled={!isEditable}/>
            <MarriageNocDetailsPreviousMarriage disabled={!isEditable}/>
            <MarriageNOCDetailsDivorcement disabled={!isEditable}/>
            <MarriageNOCDetailsWitnesses disabled={!isEditable}/>
            <MarriageNocDetailsDocuments disabled={!isEditable}/>
            <Button
              htmlType={'submit'}
              disabled={pristine || submitting || !isEditable}
            >
              <FormattedMessage id={"MarriageNOCDetails.UpdateInformation"}/>
            </Button>
          </form>
        )}
      />
    </div>
  );
};

export default MarriageNocDetailsForm;
